import { Outlet } from "react-router-dom";

// global
import { adminDataStore, messageAndErrorStore } from "../../store/Store";
// components
import AdminSidebar from "./AdminSidebar";
import useGetFetch from "../../hooks/useGetFetch";
import Loading from "../../components/Loading";
import ErrorDisplay from "../../components/ErrorDisplay";
import MessageCard from "../../components/MessageCard";

export default function AdminLanding() {
  // global
  const setAdminCompanyData = adminDataStore(
    (data) => data.setAdminCompanyData
  );
  const setAdminUsers = adminDataStore((data) => data.setAdminUsers);
  const messageTrigger = messageAndErrorStore(
    (messages) => messages.messageTrigger
  );
  const pageError = messageAndErrorStore(messages => messages.error)
  const successMessage = messageAndErrorStore(
    (messages) => messages.successMessage,
  );
  
  // get data
  const { isPending: companiesPending, error: companiesError } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/admin/companies`,
    setAdminCompanyData
  );
  const { isPending: usersPending, error: usersError } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/admin/admin-users`,
    setAdminUsers
  );

  
  if (companiesPending || usersPending) {
    return <Loading />;
  } else if (companiesError || usersError) {
    return <ErrorDisplay code={500} message={"Something Went Wrong"} />;
  } else {
    return (
      <div className="App">
        <AdminSidebar />
        <div className="container-fluid">
        {messageTrigger && <MessageCard errorMessage={pageError} successMessage={successMessage}/>}
          <nav className="navbar navbar-expand-lg">
            <div className="container-fluid">
              <div className="navbar-header">
                <div>
                  <span className="navbar-brand">
                    <div className="text-center">
                      <div className="row justify-content-start">
                        <div
                          className="col-1"
                          style={{
                            margin: "0 0 0 5px",
                            transform: "rotate(-20deg)",
                          }}
                        >
                          <h4 className="qwikr">q</h4>
                        </div>
                        <div
                          className="col-2"
                          style={{ margin: "10px 5px 0 10px" }}
                        >
                          <h4 className="qwikr">w</h4>
                        </div>
                        <div
                          className="col-1"
                          style={{
                            padding: "0 20px 0 2px",
                            transform: "rotate(10deg)",
                          }}
                        >
                          <h4 className="qwikr">i</h4>
                        </div>
                        <div
                          className="col-1"
                          style={{
                            padding: "10px 5px 0 10px",
                            transform: "rotate(-20deg)",
                          }}
                        >
                          <h4 className="qwikr">k</h4>
                        </div>
                        <div
                          className="col-2"
                          style={{
                            padding: "0 0 0 25px",
                            transform: "rotate(10deg)",
                          }}
                        >
                          <h4 className="qwikr">r</h4>
                        </div>
                        <div
                          className="col-2"
                          style={{
                            padding: "50px 0 0 10px",
                            transform: "rotate(10deg)",
                          }}
                        >
                          <span className="version">
                            {process.env.REACT_APP_VERSION}
                          </span>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </nav>
          <Outlet />
        </div>
      </div>
    );
  }
}
